import React from 'react';
import { Button, FormHelperText } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';

interface PickerStatusProps {
	status: string;
	retry?: () => void;
}

/** Says why a picker is empty (loading, failed or nothing imported), with a retry on failure. Renders nothing once ready. */
export const PickerStatus: React.FC<PickerStatusProps> = ({ status, retry }) => {
	const { t } = useGlobalization();

	const message = (() => {
		if (status === 'loading') {
			return t('Loading system types');
		}
		if (status === 'error') {
			return t('Unable to load system types.');
		}
		if (status === 'empty' || status === 'noCapable') {
			return t('No system types are available');
		}
		return undefined;
	})();

	if (!message) {
		return null;
	}

	return (
		<FormHelperText error={status === 'error'} data-cy="systemTypeStatus">
			{message}
			{status === 'error' && retry && (
				<Button size="small" onClick={retry} data-cy="systemTypeRetry">
					{t('Retry')}
				</Button>
			)}
		</FormHelperText>
	);
};
